import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"

import Layout from "../components/Layout"
import SEO from "../components/SEO"
import sanitizeHtml from "sanitize-html"

import * as inlineStyles from "../components/Layout/inlineStyles"

export default function PostTemplate(props) {
  const post = props.data.wordpressPost
  return (
    <Layout>
      <SEO title={post.title} />
      <div className="container" style={inlineStyles.singleItemContainer}>
        <h1
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(post.title.replace(/\u2028/g, " ")),
          }}
        />
        <div
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(post.content.replace(/\u2028/g, " ")),
          }}
        />
      </div>
    </Layout>
  )
}

PostTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  edges: PropTypes.array,
}

export const postQuery = graphql`
  query($id: String!) {
    wordpressPost(id: { eq: $id }) {
      title
      content
      date(formatString: "MMMM DD, YYYY")
    }
    site {
      id
      siteMetadata {
        title
      }
    }
  }
`
